// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';


export async function selectBusinessList(param?: any, options?: { [key: string]: any }) {
  return request<API.ImileResponse<any>>('/base/business/selectBusinessList', {
    data: param || {},
    method: 'POST',
    ...(options || {}),
  });
}

// 获取用户参与的业务领域下拉列表
export async function userParticipateBusiness(userCode: string) {
  return request<API.ImileResponse<any>>('/base/business/user-participate-business?userCode=' + userCode, {
    method: 'GET',
  });
}








/** 获取业务领域详情 */
export async function getBusinessDetail(id: string) {
  return request<{}>('/base/business/detail-by-id?id=' + id, {
    method: 'GET',
  }).then((aa) => {
    return aa
    // return aa?.map((item: any) => {
    //   return {...item, label: item.businessName, value: item.businessCode}
    // })
  });
}

/** 获取系统详情 */
export async function getSystemDetail(id: string) {
  return request<API.ImileResponse<any>>('/base/system/detail-by-id?id=' + id, {
    method: 'GET',
  }).then((aa) => {
    return aa
    // return aa?.map((item: any) => {
    //   return {...item, label: item.businessName, value: item.businessCode}
    // })
  });
}


/** 业务领域系统列表 */
export async function noPagedBusiness(
  params: {
    current?: number;
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.ImileResponse<API.SystemList>>('/base/business/no-page-list', {
    method: 'POST',
    data: {
      // ...params
    },
    ...(options || {}),
  });
}

/** 业务领域下拉列表 */
export async function pagedBusiness(
  params: {
    current?: number;
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.ImileResponse<API.BusinessList>>('/base/business/list', {
    method: 'POST',
    data: {
      pageNum: params.current,
      ...params
    },
    ...(options || {}),
  });
}

export async function pagedSystems(
  params: {
    current?: number;
    pageSize?: number;
    businessCode?: string;
    systemName?: string;
    systemKey?: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.ImileResponse<API.SystemList>>('/base/system/page', {
    method: 'POST',
    data: {
      currentPage: params.current,
      showCount: params.pageSize,
      businessCode: options?.businessName?.[0],
      systemLogo: params.systemName || params.systemKey,
      ...params
    },
    ...(options || {}),
  });
}


/** 创建系统 */
export async function createSystem(
  body: {},
  options?: { [key: string]: any },
) {
  return request<API.SystemList>('/base/system/create', {
    method: 'POST',
    data: {
      ...body
    },
    ...(options || {}),
  });
}
/** 创建系统 */
export async function createBusiness(
  body: {},
  options?: { [key: string]: any },
) {
  return request<API.SystemList>('/base/business/add', {
    method: 'POST',
    data: {
      ...body
    },
    ...(options || {}),
  });
}

/** 创建系统 */
export async function updateSystem(
  body: {},
  options?: { [key: string]: any },
) {
  return request<API.SystemList>('/base/system/update', {
    method: 'POST',
    data: {
      ...body
    },
    ...(options || {}),
  });
}


/** 创建系统 */
export async function updateBusiness(
  body: {},
  options?: { [key: string]: any },
) {
  return request<API.SystemList>('/base/business/update', {
    method: 'POST',
    data: {
      ...body
    },
    ...(options || {}),
  });
}

/** 更新系统备注 */
export async function updateSystemRemark(
  body: {
    id: string | number;
    remark: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.ImileResponse<any>>('/base/system/upd-remark', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}


/** 获取系统 */
export async function listSystems(
  options?: { [key: string]: any },
) {
  return request<API.ImileResponse<any>>('/issue/systemList', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 通过业务领域codes获取系统ids */
export async function getSystemIdsByBusiness(
  body: {},
  options?: { [key: string]: any },
) {
  return request<API.ImileResponse<any>>('/base/system/get-systemIds-by-business', {
    method: 'POST',
    data: {
      ...body
    },
    ...(options || {}),
    
  });
}

/** 系统下拉列表(无all版)*/
export async function selectSystems( options?: { [key: string]: any }) {
  return request<API.ImileResponse<any>>('/base/system/select', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 系统下拉列表(人员json处理版)*/
export async function selectSystemDetails() {
  return request<API.ImileResponse<any>>('/base/system/details', {
    method: 'GET',
  });
}




